import React from 'react';
import { ScrollView, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { useIsWebMobile } from '@streamster/shared/utils';

const styles = StyleSheet.create({
  wrapper: {
    paddingBottom: 50,
    paddingRight: 20,
    paddingTop: 10,
  },
  wrapperMobile: {
    paddingHorizontal: 15,
    paddingRight: 15,
  },
  wrapperInner: {
    maxWidth: 1360,
    marginHorizontal: 'auto',
    width: '100%',
    flexGrow: 1,
  },
  flexGrow: {
    flexGrow: 1,
  },
  fullHeight: {
    height: '100%',
  },
});

const PageWrapper: React.FC<{
  style?: StyleProp<ViewStyle>;
  fullHeight?: boolean;
  children?: React.ReactNode;
}> = ({ children, style, fullHeight }) => {
  const isWebMobile = useIsWebMobile();

  return (
    <ScrollView
      style={[styles.wrapper, style, isWebMobile && styles.wrapperMobile]}
      contentContainerStyle={fullHeight ? styles.fullHeight : styles.flexGrow}
    >
      <View style={styles.wrapperInner}>{children}</View>
    </ScrollView>
  );
};

export default PageWrapper;
